export default {
  "de-DE": {
    "text001": "Ergebnisse",
    "text002": "Die 8 bestplatzierten Helden erscheinen in einem Wahlturnier-Event im Spiel und den erstplatzierten Helden des Wahlturniers erhalten alle Spieler als Geschenk!",
    "text003": " Stimmen",
    "text004": "Erster Platz",
    "text005": "Zweiter Platz",
    "text006": "Dritter Platz",
    "text007": "Vierter Platz",
    "text008": "Fünfter Platz",
    "text009": "Sechster Platz",
    "text010": "Siebter Platz",
    "text011": "Achter Platz",
    "text012": "Zum Wahlturnier",
    "text013": "1 - 100",
    "text014": "Ab 101",
    "text015": "Rang",
    "text016": "Name",
    "text017": "Stimmen"
  },
  "en-GB": {
    "text001": "Results",
    "text002": "The Heroes that finish in the top 8 will appear in an in-game Voting Gauntlet, and the Hero that finishes in first place in the Voting Gauntlet will be gifted to all players!",
    "text003": "votes",
    "text004": "First place",
    "text005": "Second place",
    "text006": "Third place",
    "text007": "Fourth place",
    "text008": "Fifth place",
    "text009": "Sixth place",
    "text010": "Seventh place",
    "text011": "Eighth place",
    "text012": "To Voting Gauntlet",
    "text013": "1st - 100th",
    "text014": "101st onward",
    "text015": "Rank",
    "text016": "Name",
    "text017": "Votes"
  },
  "es-ES": {
    "text001": "Resultados",
    "text002": "Los 8 héroes más votados aparecerán en un torneo de votos. Al terminar, ¡el héroe que se haga con el primer puesto en este torneo se enviará como regalo a todos los jugadores!",
    "text003": " votos",
    "text004": "Primer puesto",
    "text005": "Segundo puesto",
    "text006": "Tercer puesto",
    "text007": "Cuarto puesto",
    "text008": "Quinto puesto",
    "text009": "Sexto puesto",
    "text010": "Séptimo puesto",
    "text011": "Octavo puesto",
    "text012": "Ir al torneo de votos",
    "text013": "1-100",
    "text014": "101 o más",
    "text015": "Puesto",
    "text016": "Nombre",
    "text017": "Votos"
  },
  "fr-FR": {
    "text001": "Résultats",
    "text002": "Les huit finalistes de l'événement s'affronteront lors d'un tournoi en jeu et le héros qui remportera le tournoi sera remis en récompense à tous les joueurs !",
    "text003": " votes",
    "text004": "Première place",
    "text005": "Deuxième place",
    "text006": "Troisième place",
    "text007": "Quatrième place",
    "text008": "Cinquième place",
    "text009": "Sixième place",
    "text010": "Septième place",
    "text011": "Huitième place",
    "text012": "Le tournoi",
    "text013": "1er - 100e",
    "text014": "101e +",
    "text015": "Rang",
    "text016": "Nom",
    "text017": "Votes"
  },
  "it-IT": {
    "text001": "Risultati",
    "text002": "Gli eroi che finiscono tra i primi 8 appariranno in una sfida voti e l'eroe che chiude al primo posto in questa sfida verrà regalato a tutti i giocatori!",
    "text003": " voti",
    "text004": "Primo posto",
    "text005": "Secondo posto",
    "text006": "Terzo posto",
    "text007": "Quarto posto",
    "text008": "Quinto posto",
    "text009": "Sesto posto",
    "text010": "Settimo posto",
    "text011": "Ottavo posto",
    "text012": "Sfida ai voti",
    "text013": "1º-100º",
    "text014": "101º e oltre",
    "text015": "Posizione",
    "text016": "Nome",
    "text017": "Voti"
  },
  "ja-JP": {
    "text001": "結果発表",
    "text002": "投票の結果、上位8位にランクインした英雄は『投票大戦』に出場します。そこで1位に輝いた英雄を全員にプレゼントします！",
    "text003": "票",
    "text004": "1位",
    "text005": "2位",
    "text006": "3位",
    "text007": "4位",
    "text008": "5位",
    "text009": "6位",
    "text010": "7位",
    "text011": "8位",
    "text012": "投票大戦へ",
    "text013": "1位〜100位",
    "text014": "101位〜",
    "text015": "順位",
    "text016": "名前",
    "text017": "票数"
  },
  "zh-TW": {
    "text001": "公布結果",
    "text002": "依據投票的結果，榮獲前8名的英雄將於「投票大戰」中登場。在「投票大戰」中榮獲第1名的英雄將作為禮物送給所有玩家！",
    "text003": "票",
    "text004": "第1名",
    "text005": "第2名",
    "text006": "第3名",
    "text007": "第4名",
    "text008": "第5名",
    "text009": "第6名",
    "text010": "第7名",
    "text011": "第8名",
    "text012": "前往投票大戰",
    "text013": "第1～100名",
    "text014": "第101名～",
    "text015": "排名",
    "text016": "角色名",
    "text017": "票數"
  },
  "en-US": {
    "text001": "Results",
    "text002": "The Heroes that finish in the top 8 will appear in an in-game Voting Gauntlet, and the Hero that finishes in first place in the Voting Gauntlet will be gifted to all players!",
    "text003": " votes",
    "text004": "First place",
    "text005": "Second place",
    "text006": "Third place",
    "text007": "Fourth place",
    "text008": "Fifth place",
    "text009": "Sixth place",
    "text010": "Seventh place",
    "text011": "Eighth place",
    "text012": "To Voting Gauntlet",
    "text013": "1st - 100th",
    "text014": "101st onward",
    "text015": "Rank",
    "text016": "Name",
    "text017": "Votes"
  },
  "es-MX": {
    "text001": "Resultados",
    "text002": "Los 8 héroes con más votos aparecerán en un torneo de votos. Al terminar, ¡el héroe que consiga el primer puesto en este torneo se enviará como regalo a todos los jugadores!",
    "text003": " votos",
    "text004": "Primer puesto",
    "text005": "Segundo puesto",
    "text006": "Tercer puesto",
    "text007": "Cuarto puesto",
    "text008": "Quinto puesto",
    "text009": "Sexto puesto",
    "text010": "Séptimo puesto",
    "text011": "Octavo puesto",
    "text012": "Ir al torneo de votos",
    "text013": "1 - 100",
    "text014": "101 o más",
    "text015": "Puesto",
    "text016": "Nombre",
    "text017": "Votos"
  },
  "fr-CA": {
    "text001": "Résultats",
    "text002": "Les huit finalistes de l'événement s'affronteront lors d'un tournoi en jeu et le héros qui remportera le tournoi sera remis en récompense à tous les joueurs!",
    "text003": " votes",
    "text004": "Première place",
    "text005": "Deuxième place",
    "text006": "Troisième place",
    "text007": "Quatrième place",
    "text008": "Cinquième place",
    "text009": "Sixième place",
    "text010": "Septième place",
    "text011": "Huitième place",
    "text012": "Le tournoi",
    "text013": "1er - 100e",
    "text014": "101e +",
    "text015": "Rang",
    "text016": "Nom",
    "text017": "Votes"
  },
  "pt-BR": {
    "text001": "Resultados",
    "text002": "Os oito heróis mais votados participarão de um torneio de votos no jogo, e o herói mais votado no torneio de votos será enviado a todos os jogadores!",
    "text003": " votos",
    "text004": "1º lugar",
    "text005": "2º lugar",
    "text006": "3º lugar",
    "text007": "4º lugar",
    "text008": "5º lugar",
    "text009": "6º lugar",
    "text010": "7º lugar",
    "text011": "8º lugar",
    "text012": "Torneio de votos",
    "text013": "1º - 100º",
    "text014": "101º ou mais",
    "text015": "Colocação",
    "text016": "Nome",
    "text017": "Votos"
  }
}